import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back copy",
  "use": "icon-back copy-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-back copy\"><path fill=\"currentColor\" d=\"M224 480h640a32 32 0 110 64H224a32 32 0 010-64z\" /><path fill=\"currentColor\" d=\"M237.248 512l265.408 265.344a32 32 0 01-45.312 45.312l-288-288a32 32 0 010-45.312l288-288a32 32 0 1145.312 45.312L237.248 512z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol